import React from 'react';
import LogoFooter from './LogoFooter';
import SocialIconsMenu from '../../molecules/social-icon/SocialIconsMenu';

const FooterTopBar = ({ disableLinkLogo }) => {
  return (
    <div className='footer__top-bar' data-submodule-name='footer-top-bar'>
      <LogoFooter disableLinkLogo={disableLinkLogo} />
      <SocialIconsMenu />
    </div>
  );
};

export default FooterTopBar;
